import { createContext, use } from 'react';
import { DEFAULT_LOCALE, type Locale } from '@ceo/shared';

export const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export const useLocale = () => use(LocaleContext);

/** Builds a locale-aware path. English lives at the root, Albanian under /sq (like WPML's ?lang=sq). */
export function localePath(locale: Locale, path = '/'): string {
  if (locale === DEFAULT_LOCALE) return path;
  return path === '/' ? `/${locale}` : `/${locale}${path}`;
}

/** Same page in the other language. */
export function switchLocalePath(pathname: string, to: Locale): string {
  const bare = pathname.replace(/^\/sq(?=\/|$)/, '') || '/';
  return localePath(to, bare);
}

export const useLocalePath = () => {
  const locale = useLocale();
  return (path = '/') => localePath(locale, path);
};

/** Locale of a route loader request (Albanian routes live under /sq). */
export function localeFromRequest(request: Request): Locale {
  return /^\/sq(\/|$)/.test(new URL(request.url).pathname) ? 'sq' : DEFAULT_LOCALE;
}
